import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20background%20with%20dramatic%20red%20velvet%20curtains%2C%20golden%20stage%20lights%2C%20film%20reel%20elements%2C%20atmospheric%20theater%20setting%2C%20warm%20spotlight%20beams%2C%20elegant%20and%20grand%20cinema%20hall%20ambience%2C%20rich%20dark%20tones%20with%20golden%20accents&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
        alt="6080电影网"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 mb-4 leading-tight">
            最新大片<span className="text-primary-400">·</span>抢先看
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
            高清画质不缓冲，免费无广告，极速秒开。<br className="hidden md:block" />最新电影一次看个够。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/all"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="whitespace-nowrap px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 inline-flex items-center gap-2"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              立即观看
            </Link>
            <Link
              to="/category/all"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="whitespace-nowrap px-8 py-3.5 border border-background-50/30 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/10 transition-all duration-300"
            >
              浏览全部电影
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
        </div>
      </div>
    </section>
  );
}